var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup"},[_c('div',{staticClass:"popup-content"},[_c('div',{staticClass:"close-button",on:{"click":_vm.closePopup}},[_vm._v("✖")]),_c('div',{staticClass:"popup-title"},[_vm._v("QR Code")]),_c('div',{staticClass:"qrcode-container",attrs:{"id":"qrcode"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }